export const UNICITY_GO_MARKETS: ReadonlySet<string> = new Set([
  // Americas
  "US", "CA", "CO", "DO", "MX",
  // Europe
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR",
  "HU", "IS", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "NO", "PL", "PT",
  "RO", "SK", "SI", "ES", "SE", "CH", "TR", "GB",
  // Middle East & Africa
  "DZ", "EG", "JO", "KE", "KW", "LB", "MA", "OM", "SA", "AE",
  // Oceania
  "AU", "NZ",
  // Individual
  "PH", "IN",
  // Asia Pacific (excluded from broader APAC)
  "MY", "SG", "BN", "HK", "TW",
]);

export const UNICITY_GO_URL = "https://www.unicity.com/usa/en/go";

export const UNICITY_GO_IOS_URL =
  "https://apps.apple.com/us/app/unicity-go/id6504302921";

export const UNICITY_GO_ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.unicity.office.feelgreatbiz";

export const UNICITY_GO_SESSION_KEY = "unicity_go_banner_dismissed";
